// extracted by mini-css-extract-plugin
module.exports = {"main":"Footers_main__Vdgo2"};